import useSWR from 'swr';
import { createRestApiClient } from '..';
import { getUserToken } from '../../Utils/helper';
import { tabByKeyFetcher } from '../CategoryPage';

export const trendingFetcher = async (url = `api/getTrending`) => {
  const restApiClient = createRestApiClient();
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
    })
    .then((res) => res.data);
  return data;
};

export function useGetTrendingData(initialData) {
  const options = {
    fallbackData: initialData,
    revalidateOnMount: true,
  };
  if (!initialData) {
    delete options.initialData;
  }
  const { data, error } = useSWR(`api/getTrending`, trendingFetcher, options);
  return {
    trendingData: data,
    trendingLoading: !error && !data,
    trendingError: error,
  };
}

export const topArticleFetcher = (index) => {
  const restApiClient = createRestApiClient();
  const url = `api/getWebArticles?page=${index}&limit=9&clear=true`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
    })
    .then((res) => res.data);
};

export function useGetTopArticleData(initialData, index) {
  const options = {
    fallbackData: initialData,
    revalidateOnMount: false,
  };
  if (!initialData) {
    delete options.initialData;
  }
  const { data, error } = useSWR(
    `api/getWebArticles?page=${index}&limit=6&clear=true`,
    topArticleFetcher,
    options,
  );
  return {
    topArticlesData: data,
    topArticlesLoading: !error && !data,
    topArticlesError: error,
  };
}

export const utilitesFetcher = (url = `api/utilities`) => {
  const restApiClient = createRestApiClient();
  return restApiClient
    .request({
      method: 'GET',
      url: url,
    })
    .then((res) => res.data);
};

export function useGetUtilities(initialData, index) {
  const options = {
    fallbackData: initialData,
    revalidateOnMount: false,
  };
  if (!initialData) {
    delete options.initialData;
  }
  const { data, error } = useSWR(`api/utilities`, utilitesFetcher, options);
  return {
    utilitiesData: data,
    utilitiesLoading: !error && !data,
    utilitiesError: error,
  };
}

export const searchDataFetcher = (req) => {
  const restApiClient = createRestApiClient();
  const url = `api/webSearch`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: req,
    })
    .then((res) => res.data);
};

export function useSearchData(initialData) {
  const options = {
    fallbackData: initialData,
    revalidateOnMount: false,
  };
  if (!initialData) {
    delete options.initialData;
  }
  const { data, error } = useSWR(`api/webSearch`, searchDataFetcher, options);
  return {
    searchData: data,
    searchDataLoading: !error && !data,
    searchDataError: error,
  };
}

export const getFeedsData = (params, feed_stage, language) => {
  const restApiClient = createRestApiClient();
  let token = 'Bearer e364f56f-109e-4033-8d53-e2779f51247e';
  if (feed_stage === 'pregnancy') {
    token = 'Bearer 7wo8l8dz-kjx8-pqws-eolb-69oi5pjy7nda';
  }
  const url = `api/v2/getFeeds`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: {
        'authorization': token,
        'Accept-Language': language || 'en',
      },
    })
    .then((res) => res.data);
};

export const getTagData = (params) => {
  const restApiClient = createRestApiClient();
  const url = `api/getTagDetail`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
    })
    .then((res) => res.data.data);
};

export const getTagDetailPageByTagId = (params) => {
  const restApiClient = createRestApiClient();
  const url = `new/topicDetailPage/getTagDetailPageByTagId`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data);
};

const fetchData = async (tagId) => {
  const getTagDetail = await getTagDetailPageByTagId({ tagId: tagId });
  const generalTabsName = getTagDetail?.data?.generalTabs;
  const tagData = getTagDetail?.data?.tagData;
  const checkToShowNewDesign = tagData?.is_general_tab_eligible;
  const params = {
    key: 'topic_all',
    tagId: tagId,
    isForGeneralTabFromWeb: true,
  };
  const generalTabsDataInDetail = checkToShowNewDesign
    ? await tabByKeyFetcher(params)
    : null;
  const generalTabsProductsData = generalTabsDataInDetail?.data || null;
  const feedData = await getFeedsData(
    {
      tag: tagId,
      page: 1,
      type: 'featured',
      shortenFeedResponse: true,
    },
    //context.query.stage,
  );
  return {
    feedData,
    tagData,
    generalTabsName,
    generalTabsProductsData,
    checkToShowNewDesign,
  };
};

export function getTopicDetailData(tagId, initialData) {
  const options = {
    fallbackData: initialData,
    revalidateOnMount: true,
  };
  const { data, error } = useSWR(
    `api/getFeedDetails/${tagId}`,
    () => fetchData(tagId),
    options,
  );
  return {
    topicDetailData: data,
  };
}

export const getTopicList = async (key) => {
  const restApiClient = createRestApiClient();
  const url = `/api/getTopicListV2`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: { key: key },
    })
    .then((res) => res.data.data);
};
export const getSearchResults = async (params) => {
  const restApiClient = createRestApiClient();
  const url = `/api/searchQuery`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
    })
    .then((res) => res.data.data);
};

export const getMostViewedWebContent = async (params, language) => {
  const restApiClient = createRestApiClient();
  const url = `/new/content/getMostViewedWebContent`;
  const lang =
    language == 'bangla' ? 'bn' : language == 'hindi' ? 'hi' : language;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: {
        'authorization': getUserToken(),
        'Accept-Language': language || 'en',
      },
    })
    .then((res) => res.data.data);
};
export const getEligibilityForAd = async (token) => {
  const restApiClient = createRestApiClient(false, true);
  const url = `/api/getUserEligibiltyForAd`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      headers: {
        authorization: token || getUserToken(),
      },
    })
    .then((res) => res.data.data);
};
